import React from 'react';
import PropTypes from 'prop-types';
import ToggleLabel from '../common/EnhancedGridFeature/ToggleLabel';
import GlobalDelete from '../common/EnhancedGridFeature/GlobalDelete';
import { FLEX_STUDY_TAG } from '../../constants';


const ToolPaletteHeader = props => {
  const {
    renderLength,
    toggleNo,
    title,
    dataGridItems,
    gridType,
    icon,
    study,
    standardBaseCount,
    targetCountFlag,
    showToggleMenu,
    deleteSelected,
    renderToggleMenu,
    toggleLabel,
    checkedValue,
  } = props;
  return (
      <label
        className={`accordion__trigger tool_img ${icon} toolPalette_header`}
        title={title}
      >
        <label
          htmlFor={toggleNo}
        >
          {title}
          <span className="countNum">
            {(gridType === 'BasesDataGrid' ? renderLength(dataGridItems) + standardBaseCount : renderLength(dataGridItems)) +
              ((gridType === 'BasesDataGrid' || gridType === 'DataHaulBasesDataGrid') &&
                study &&
                !study.toLowerCase().includes(FLEX_STUDY_TAG)
                ? 1
                : 0)}{targetCountFlag ? '/10' : ''}
          </span>
        </label>
      </label>
  );
};

ToolPaletteHeader.propTypes = {
  dataGridItems: PropTypes.arrayOf(PropTypes.shape({})),
  icon: PropTypes.string,
  gridType: PropTypes.string,
  renderLength: PropTypes.func,
  toggleNo: PropTypes.string,
  title: PropTypes.string,
  standardBaseCount: PropTypes.number,
  connectDropTarget: PropTypes.func,
};

export default ToolPaletteHeader;
